export const SalesOrderStatusConstant :any = {
  SHIPPED: 'shipped',
  AWAITING_SHIPMENT: 'awaiting_shipment',
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  PARTIALLY_SHIPPED: 'partially_shipped',
  ON_HOLD: 'on_hold',
};

export const splitOrdersLookUp = [
  {
    label: 'Without Split Orders Only',
    value: '0',
  },
  {
    label: 'With Split Orders Only',
    value: '1',
  },
];

export const lineItemsLookUp = [
  {
    label: 'Without Line Items Only',
    value: '0',
  },
  {
    label: 'With Line Items Only',
    value: '1',
  },
];

export const luminousSkusLookUp = [
  {
    label: 'With matched Luminous SKUs Only',
    value: '0',
  },
  {
    label: 'With missing Luminous SKUs Only',
    value: '1',
  },
];

export const postedOrdersLookUp = [
  {
    label: 'Unallocated Orders Only',
    value: '0',
  },
  {
    label: 'Allocated Orders Only',
    value: '1',
  },
];

export const orderStatusLookUp = [
  {
    label: 'PENDING',
    value: 'pending',
  },
  {
    label: 'SHIPPED',
    value: 'shipped',
  },
  {
    label: 'CANCELLED',
    value: 'cancelled',
  },
  {
    label: 'AWAITING_SHIPMENT',
    value: 'awaiting_shipment',
  },
  {
    label: 'ON_HOLD',
    value: 'on_hold',
  },
];

export const skusOrKitsLookUp = [
  {
    label: 'With Master SKUs Only',
    value: '1',
  },
  {
    label: 'With Kits Only',
    value: '2',
  },
];

export const fulfillmentStatusLookUp = [
  {
    label: 'Unfulfilled',
    value: 'UNFULFILLED',
  },
];

export const FulfillmentStatusConstant = {
  noEnoughStocks: 'NO_ENOUGH_STOCKS',
  notInPicking: 'NOT_IN_PICKING',
};

export const PicklistStatusConstant :any = {
  PICKLIST_CREATED: 'CREATED',
  PICKLIST_PICKING: 'PICKING IN-PROGRESS',
  PICKLIST_PICKED: 'PACKING',
  NOT_IN_PICKING: 'NOT CREATED',
  NO_ENOUGH_STOCKS: 'NOT ENOUGH STOCKS',
  PICKLIST_PACKED: 'COMPLETED',
};

export const PicklistStatusOptionConstant :any = {
  PICKLIST_CREATED: 'PICKLIST_CREATED',
  PICKLIST_PICKING: 'PICKLIST_PICKING',
  PICKLIST_PICKED: 'PICKLIST_PICKED',
  NOT_IN_PICKING: 'NOT_IN_PICKING',
  NO_ENOUGH_STOCKS: 'NO_ENOUGH_STOCKS',
  PICKLIST_PACKED: 'PICKLIST_PACKED',
};

export enum ESalesOrderSource {
  TRANSFER_ORDER = 'transfer_order',
}

export enum EQuickFulfillmentActions {
  CREATE_PICKLIST = 'create_picklist',
  EXPORT_PACKING_SLIP = 'export_packing_slip',
  BULK_UPDATE_TAGS = 'bulk_update_tags',
  BULK_UPDATE_ORDER_STATUS = 'bulk_update_order_status',
}

export enum ESalesOrderAction {
  EDIT_SALES_ORDER = 'edit_sales_order',
  UPDATE_ORDER_STATUS = 'update_order_status',
  PUSH_TO_OMS = 'push_to_oms',
  UPDATE_TAGS = 'update_tags',
  CREATE_PICKLIST = 'create_picklist',
  ADD_TRACKING_NUMBER = 'add_tracking_number',
  EXPORT_PACKING_SLIP = 'export_packing_slips',
  EXPORT_SALES_ORDER = 'export_sales_orders',
  PRINT_SHIPPING_LABELS = 'print_shipping_labels',
  PREVIEW_PICKLIST = 'preview_picklist',
  DELETE_SALES_ORDER = 'delete_sales_order',
  UPDATE_CUSTOM_FIEDS = 'update_custom_fields',
  PUSH_FULFILLMENT = 'push_fulfillment',
  UNPOST_ORDER = 'unpost_order',
  CREATE_INVOICE_FROM_SHIPMENT = 'create_invoice_from_shipment',
  AUTO_GENERATE_FULFILLMENT_ORDERS = 'auto_generate_fulfillment_orders',
}
